{
  "vettingApp": "Application de gestion des demandes de contrôle de la confidentialité",

  "flipLang": "en",

  "site":{
    "azurePortal": "Portail Microsoft Azure",
    "skipMainContent":"Aller au contenu principal",
    "skipToFooter":"Aller au bas de page",
    "header":{
      "title": "Gestion des demandes de contrôle de la confidentialité",
      "languageSelection":"Sélection de la langue",
      "languageChange":"English",
      "logout":"Déconnexion",
      "showProjectList": "Montrer la liste de projets",
      "hideProjectList": "Cacher la liste de projets",
      "help": "Aide",
      "vettingHandbook": "Manuel de contrôle de la confidentialité",
      "opensNewTab": "Ouvre dans un nouvel onglet",
      "trainingDoc": "Document d'entrainement",
      "getSupport": "Obtenir de l’aide",
      "accountMenu": "Menu de compte",
      "betaAlert": "Ceci est une version bêta. Cette application fonctionne mieux lorsqu’elle est utilisée sur un ordinateur ou un ordinateur portable."
    },
    "footer":{
      "imageCaption":"Symbole du gouvernement du Canada",
      "dateModified": "Date de modification:",
      "termsConditions": "Conditions",
      "privacy":"Protection de la vie privée"
    },
    "session":{
      "sessionTitle":"Prolonger la session?",
      "sessionClosing": "Votre session se terminera dans {{time}}. Veuillez sélectionner le bouton « Prolonger la session » pour prolonger votre session.",
      "extendSession": "Prolonger la session"
    },
    "requestTable":{
      "rowsPerPageLabel": "Lignes par page: ",
      "vettingRequestDashboard":"Tableau de bord de demandes de contrôle de la confidentialité",
      "rowsPerPageCount": "de"
    },
    "brandingAlt": "Statistique Canada"
  },
  "url":{
    "statcan": "https://www.statcan.gc.ca/fra/debut",
    "privacy": "https://www.statcan.gc.ca/fra/reference/privee",
    "termsConditions": "https://www.statcan.gc.ca/fra/reference/avis"
  },
  "dialog":{
    "close": "Fermer",
    "assigneeDetailsTitle2":"Responsables",
    "assigneeDetailsTitleLead":"Responsable",
    "assigneeDetailsSupport": "Aide",
    "assigneeDetailsTitle":"Renseignement sur le responsable",
    "assigneeDetailsClose":"Renseignement sur le responsable - fermer",
    "requesterDetailsTitle":"Renseignements sur le demandeur",
    "requesterDetailsClose":"Renseignements sur le demandeur - fermer",
    "assignAsSupportTitle":"Affectez-moi comme soutien",
    "assignAsSupportClose":"Affectez-moi comme soutien – Fermer",
    "assignAsLeadTitle":"Affectez-moi comme responsable",
    "assignAsLeadClose":"Affectez-moi comme responsable – Fermer",
    "assignAsLeadMainText":"Pour vous affecter à la demande, vous devez d’abord saisir un numéro de téléphone sécurisé",
    "assignAsLeadApply":"Affecter",
    "assignAsLeadCancel":"Annuler",
    "noLeadNoLeadAssigned":"Continuer sans responsable?",
    "noLeadNoLeadClose":"Continuer sans responsable? – Fermer",
    "noLeadMainText":"Si vous continuez, la demande ne sera pas associée à un responsable et le demandeur sera avisé du changement.",
    "noLeadCancel":"Annuler",
    "noLeadContinue":"Continuer",
    "newRequestDefaultTitle":"Demande sans titre",
    "warningConfidentialText":"N’incluez aucun renseignement confidentiel.",
    "labelCut":"La fonction Couper a été désactivée pour des raisons de sécurité.",
    "labelCopy":"La fonction Copier a été désactivée pour des raisons de sécurité.",
    "labelPaste":"La fonction Coller a été désactivée pour des raisons de sécurité.",
    "analystInfo":"Renseignements de l’Analyste",
    "analystLabelClose":"Renseignements de l’Analyste – Fermer",
    "newRequestTitle":"Nouvelle demande de contrôle de la confidentialité",
    "newRequestLabelClose":"Nouvelle demande de contrôle de la confidentialité – Fermer",
    "newRequestLabelName":"Saisissez les renseignements ci-dessous pour amorcer votre demande...",
    "newRequestLabelDescription": "Sélectionnez le dossier associé à cette demande. Si le dossier de la demande est introuvable, veuillez l’ajouter au lecteur partagé de votre machine virtuelle. Vous devrez placer tous les fichiers associés dans ce dossier.",
    "newRequestLabelFolder": "Le chemin d’accès au dossier de la demande",
    "newRequestFolderError": "Il faut fournir un dossier",
    "newRequestLabelReqName":"Nom de la demande",
    "newRequestCancel":"Annuler",
    "newRequestClose":"Annuler",
    "newRequestCreate":"Créer",
    "withdrawReason":"Sélectionner un motif de retrait.",
    "withdrawReasonLabel":"Motif de retrait",
    "withdrawTitle":"Retrait de la demande",
    "withdrawRequest":"Retrait",
    "withdrawCancel":"Annuler",
    "updateTitle":"Demander des changements",
    "updateCancel":"Annuler",
    "updateContentPara1":"Ce que vous devez faire...",
    "updateContentPara2":"Cliquez sur le bouton « Demander des changements » pour informer le demandeur que des changements devront être apportés à la demande.",
    "updateContentPara3":"Communiquez avec le demandeur au moyen d’un canal de communication sécurisé afin de l’informer des changements requis.",
    "updateSubmitRequest":"Demander des changements",
    "updateClose":"Demander des changements – Fermer",
    "approvedBillableHours":"Temps facturable",
    "approvedTitle":"Approuver la demande",
    "approvedLabelHours":"Heures",
    "approvedLabelMinutes":"Minutes",
    "approvedCancel":"Annuler",
    "approvedSubmit":"Soumettre",
    "approvedLabelClose":"Approuver la demande – Fermer",
    "approveBillabeMinutesError":"Saisir les minutes facturables",
    "approveBillabeHoursError":"Saisir les heures facturables",
    "deniedTitle":"Ne pas approuver la demande",
    "deniedBillableHours": "Temps facturable",
    "deniedLabelHours": "Heures",
    "deniedLabelMinutes": "Minutes",
    "deniedReason":"Raison",
    "deniedSelectOption":"Sélectionner une option",
    "deniedComments":"Commentaires",
    "deniedCancel":"Annuler",
    "deniedSubmit":"Soumettre",
    "deniedLabelClose":"Ne pas approuver la demande – Fermer",
    "deniedBillabeHoursError":"Saisir les heures facturables",
    "deniedBillabeMinutesError":"Saisir les minutes facturables",
    "deniedReasonError":"Sélectionnez une raison",
    "deniedCommentError":"Saisir un commentaire",
    "deleteText":"Si vous supprimez cet élément, vous ne pourrez pas revenir en arrière.",
    "deleteSubmit":"Supprimer",
    "deleteCancel":"Annuler",
    "deleteLabelClose":"Désirez-vous supprimer de manière permanente? – Fermer",
    "deleteTitle":"Désirez-vous supprimer de manière permanente?",
    "assignPhoneNumber":"Fournissez un numéro de téléphone.",
    "assignLabelPhoneNumber":"Numéro de téléphone",
    "assignPhoneNumberError":"Saisissez un numéro de téléphone.",
    "assignCancel":"Annuler",
    "assignSubmit":"Continuer",
    "assignLabelClose":"Affectez-moi comme responsable – Fermer",
    "supportFormTitle":"Obtenir de l’aide",
    "supportFormTitleClose":"Obtenir de l’aide - fermer",
    "supportFormContentPara1":"Avez-vous besoin d’aide?",
    "supportFormContentPara2":"Sélectionnez les étapes pour lesquelles vous avez besoin d’aide.",
    "supportFormContentPara3":"Sélectionnez tout ce qui s’applique.",
    "supportFormContentPara4":"Cliquez sur le bouton « Obtenir de l’aide ». Un de nos analystes communiquera avec vous pour résoudre le problème. Nous tenterons de communiquer avec vous dans un délai de un à deux jours ouvrables.",
    "supportFormCancel" :"Annuler",
    "supportFormSubmit":"Obtenir de l’aide",
    "supportContentPara1":"Avez-vous besoin d’aide?",
    "supportContentPara2":"Cliquez sur le bouton « Obtenir de l’aide ». Un de nos analystes communiquera avec vous pour résoudre le problème. Nous tenterons de communiquer avec vous dans un délai de un à deux jours ouvrables.",
    "supportCancel" :"Annuler",
    "supportClose": "Annuler",
    "supportSubmit":"Obtenir de l’aide",
    "supportTitle":"Obtenir de l’aide",
    "unassignTitle":"Annuler l’affectation que j’avais",
    "unassignText":"Si vous choisissez de continuer, la demande n’aura plus d’analyste principal.",
    "unassignCancel":"Annuler",
    "unassignSubmit":"Annuler l'affectation",
    "unassignLabelClose":"Annuler l'affectation que j’avais – Fermer",
    "manageTeamNoLead":"Pas de responsable affecté",
    "manageTeamTitle":"Gérer l'équipe",
    "manageTeamLead":"Responsable",
    "manageTeamSearchSupport":"Rechercher des analystes de soutien",
    "manageTeamAddSupport":"Ajouter un analyste de soutien",
    "manageTeamSupportAnalysts":"Analystes de soutien",
    "manageTeamCancel":"Annuler",
    "manageTeamSubmit":"Appliquer",
    "manageTeamLabelClose":"Gérer l'équipe - Fermer",
    "saveBeforeLeaveTitle": "Enregistrer avant de quitter?",
    "saveBeforeLeaveClose": "Enregistrer avant de quitter - Fermer",
    "saveBeforeLeaveMessage": "Si vous n’enregistrez pas votre travail, vos changements seront perdus.",
    "saveBeforeLeaveDontSave": "Ne pas enregistrer",
    "saveBeforeLeaveCancel": "Annuler",
    "saveBeforeLeaveSave": "Enregistrer",
    "outputMethodHelpTitle": "Aide pour méthode relative aux données de sortie",
    "outputMethodHelpClose": "Aide pour méthode relative aux données de sortie - Fermer",
    "outputMethodHelpCloseButton": "Fermer",
    "addFileTitleView": "Affichage d’un fichier justificatif",
    "addFileTitleEdit": "Modification d’un fichier justificatif",
    "addFileTitleAdd": "Ajout d’un fichier justificatif",
    "addFileTitleClose": "Ajout d’un fichier - Fermer",
    "addFileContent_syntaxFile": "Sélectionner un fichier de syntaxe ou un fichier journal",
    "addFileContent_variableListFile": "Sélectionner une liste de variables et/ou des descriptions de variables",
    "addFileContent_other": "Sélectionner un fichier justificatif supplémentaire",
    "addFileContent_correctDocFile": "Sélectionner les documents justificatifs adéquats (voir les règles de contrôle de la confidentialité)",
    "addFileContent_frequencyTablefile": "Sélectionner un tableau de fréquences non pondérées pour le nombre de répondants",
    "addFileContent_sampleSizeFile": "Sélectionner une taille non pondérée d’échantillon",
    "addFileContent_crossTabFile": "Sélectionner un tableau croisé non pondéré",
    "addFileContent_subTotalsFile": "Sélectionner les sous-totaux non pondérés pour les catégories de variables dichotomiques corrélées avec une variable continue",
    "addFileContent_unroundedFile": "Sélectionner une version non arrondie de ces données de sortie",
    "addFileContent_dominanceTestingFile": "Sélectionner les résultats des tests",
    "addFileContent_continuousVariablesSensitivityFile" : "Sélectionner les résultats du test de sensibilité",
    "addFileContent_residualTablesFile": "Sélectionner un tableau résiduel (voir l’orientation du contrôle de la confidentialité)",
    "addFileContent_previousRelease_residualTablesFile": "Sélectionner un tableau résiduel (voir l’orientation du contrôle de la confidentialité)",
    "addFileContent_bothSetsFile": "Sélectionner les deux ensembles de syntaxe dans lesquels des changements sont mis en évidence",
    "addFileContent_previousRelease_bothSetsFile": "Sélectionner les deux ensembles de syntaxe dans lesquels des changements sont mis en évidence",
    "addFileFilePath": "Chemin d’accès au fichier",
    "addFileNotes": "Notes",
    "addFileCancel": "Annuler",
    "addFileClose": "Fermer",
    "addFileUpdate": "Mettre à jour",
    "addFileAdd": "Ajouter",
    "addFileError": "Ce champs est requis"
  },
  "notifications":{
    "vettingRequestCreated":"Demande créée.",
    "vettingRequestWithdrawn":"Demande retirée.",
    "vettingRequestDeleted":"Demande supprimée.",
    "vettingRequestSubmitted":"Demande soumise.",
    "vettingRequestReopened":"La demande a été remise dans la liste des demandes actives en tant que brouillon.",
    "assignedAnalystsUpdated":"Les changements concernant le responsable ont été appliqués",
    "vettingRequestApproved":"Demande approuvée.",
    "vettingRequestAssignToMe":"Attribué en tant que responsable",
    "vettingRequestAssignAsSupport":"Attribué en tant que soutien",
    "vettingRequestUnassigned":"Non attribuée",
    "vettingRequestDenied":"Demande non approuvée",
    "vettingRequestUpdateRequested":"Demande de changement envoyée",
    "vettingRequestStartReview":"Demande d’examen amorcée",
    "vettingRequestHelpRequested":"Demande d’aide envoyée",
    "vettingRequestDuplicated":"Demande dupliquée"
  },
  "contextMenu":{
    "assigneeDetails":"Renseignement sur le responsable",
    "requesterDetails":"Renseignements sur le demandeur",
    "edit":"Modifier",
    "view":"Afficher la demande",
    "delete": "Supprimer",
    "summary":"Résumé",
    "withdraw":"Retrait",
    "submit":"Soumettre",
    "resubmit":"Soumettre",
    "reopen":"Réactiver",
    "dialogBox":{
      "message": "Voulez-vous vraiment supprimer cette demande?"
    },
    "startReview":"Commencer l’examen",
    "unassign":"Annuler l’affectation de l’utilisateur",
    "unassignMe":"Annuler mon affectation",
    "makeSupport":"Transformer en soutien",
    "makeMeSupport": "Affectez-moi comme soutien",
    "makeLead":"Affecter un utilisateur en tant que responsable",
    "manageTeam":"Gérer les personnes affectées",
    "assignToMe":"Affectez-moi comme responsable",
    "requestUpdate":"Demander des changements",
    "denyRequest":"Ne pas approuver",
    "approve":"Approuver",
    "duplicate": "Dupliquer"
  },
  "assigneeDrawer":{
    "noLeadAssigned":"Pas de responsable affecté",
    "you":" (Vous)",
    "noSupportAssigned":"Pas de soutien attribué",
    "manageAssignees":"Gérer les personnes affectées",
    "closePanel": "Gérer le volet des personnes affectées – Fermer le volet",
    "assignees":"Personnes affectées",
    "assignMeAs":"Affectez-moi comme",
    "assignMeAsLead":"Affectez-moi comme responsable",
    "assignMeAsSupport":"Affectez-moi comme soutien",
    "lead":"Responsable",
    "support":"Soutien",
    "cancel":"Annuler",
    "apply":"Appliquer"
  },
  "summaryDrawer":{
    "summary":"Résumé de la demande de contrôle de la confidentialité",
    "projectName":"Nom du projet",
    "viewRequest": "Voir demande de contrôle de la confidentialité",
    "filesRequested":"Fichiers demandés",
    "billableHours":"Temps facturable",
    "labelBillableMinutes":"minute",
    "labelBillableMinutes_plural":"minutes",
    "labelBillableHours":"heure",
    "labelBillableHours_plural":"heures",
    "principalAnalyst":"Analyste principal",
    "latestStatusLabel":{
      "approved":"Approuvée",
      "updateRequest":"Changements demandés",
      "denied":"Non approuvée",
      "submitted":"Soumis",
      "draft":"Créée",
      "disclosureAnalysis":"Examen amorcé",
      "withdraw":"Retirée"
    },
    "labelRequestInfo":"Volet de demande de renseignements – Fermer le volet"
  },
  "commonDashboard":{
    "updatedOn":{
      "justNow":"Il y a quelques instants",
      "minAgo":"Il y a {{count}} minute",
      "minAgo_plural":"Il y a {{count}} minutes",
      "hourAgo":"Il y a {{count}} heure",
      "hourAgo_plural":"Il y a {{count}} heures"
    }
  },
  "adminDashboard":{
    "title":"Tableau de bord - Administration"
  },
  "researcherDashboard":{
    "title":"Tableau de bord • Gestion des demandes de contrôle de la confidentialité • Analyse des données en tant que service • Statistique Canada",
    "newVettingRequest":"Nouvelle demande de contrôle de la confidentialité",
    "tabs":{
      "active":"Active",
      "withdrawn":"Retirée",
      "approved":"Approuvée",
      "denied": "Non approuvée"
    },
    "tableHeader":{
      "id":"ID",
      "request":"Demande",
      "researcher":"Demandeur",
      "status":"Statut",
      "analyst":"Analyste",
      "createdOn":"Créée le",
      "updatedOn": "Mise à jour le"
    },
    "tabsLabel": "Onglets des demandes de contrôle de la confidentialité",
    "analystCell":{
      "labelUnassigned": "Non attribuée"
    }
  },
  "analystDashboard":{
    "title":"Tableau de bord • Gestion des demandes de contrôle de la confidentialité • Analyse des données en tant que service • Statistique Canada",
    "tabs":{
      "assignedToMe":"Attribuée à moi",
      "unassigned":"Non attribuée",
      "active":"Active",
      "approved":"Approuvée",
      "denied": "Non approuvée"
    },
    "tableHeader":{
      "id":"ID",
      "request":"Demande",
      "researcher":"Demandeur",
      "project": "Projet",
      "status":"Statut",
      "lead":"Personne(s) assignée(s)",
      "createdOn":"Créée le",
      "updatedOn": "Mise à jour le"
    },
    "tabsLabel": "Onglets des demandes de contrôle de la confidentialité",
    "manageTeamLink":"Gérer l'équipe",
    "labelNoLead":"Pas de responsable",
    "labelSupport":"Soutien",
    "analystCell":{
      "labelUnassigned": "Non attribuée"
    }
  },
  "drawer":{
    "projectsCaption":"Projets",
    "itemAll":"Tous"
  },
  "administration":{
    "drawer":{
      "menuCaption":"Menu"
    }
  },
  "copyPaste":{
    "understood": "Compris",
    "functionalityDisabled": "Les fonctionnalités Couper, Copier et Coller ont été désactivées sur les champs de texte pour des raisons de sécurité."
  },
  "inputs":{
    "required": "requis",
    "virtualizedAutocomplete":{
      "clearText": "effacer",
      "closeText": "fermer",
      "openText": "ouvrir"
    }
  },
  "requestForm": {
    "requestReviewFolderName": "Nom du dossier de révision de l'analyste",
    "toolTipMoreInformation": "Plus d’information",
    "title": "Demande {{request}} • Gestion des demandes de contrôle de la confidentialité • Analyse de données en tant que service • Statistique Canada",
    "project": "Projet",
    "request": "Demande",
    "status": "Statut",
    "requester": "Demandant",
    "assignee": "Assignées",
    "unassigned": "Non attribuée",
    "noLead": "Pas de responsable",
    "support": "{{count}} soutien",
    "back": "Retour",
    "next": "Suivant",
    "submitRequest": "Soumettre la demande",
    "cancel": "Annuler",
    "close": "Fermer",
    "errors": "{{count}} erreur",
    "errors_plural": "{{count}} erreurs",
    "yes": "Oui",
    "no": "Non",
    "errorWithRequest": "Il semble y avoir une erreur dans cette demande et celle-ci doit être supprimée. Les dossiers associés à cette demande ont été supprimés de la mémoire.",
    "successSave": "Demande sauvegardée",
    "areYouSure": "Êtes-vous sûr?",
    "outputAdded": "fichier de sortie ajouté",
    "outputEdited": "fichier de sortie mis à jour",
    "outputDeleted": "fichier de sortie supprimé",
    "otherSupportingAdded": "fichier de soutien ajouté",
    "otherSupportingEdited": "fichier de soutien modifié",
    "otherSupportingDeleted": "fichier de soutien supprimé",
    "toolbar":{
      "dashboard": "Tableau de bord",
      "save": "Sauvegarder",
      "submit": "Soumettre",
      "delete": "Supprimer",
      "requestUpdate": "Demander des changements",
      "resolve": "Résoudre",
      "approve": "Approuver",
      "deny": "Ne pas approuver",
      "assignMeLead": "Affectez-moi comme responsable",
      "assignMeSupport": "Affectez-moi comme soutien",
      "unassignMe": "Annuler mon affectation",
      "withdraw": "Retrait",
      "reactivate": "Réactiver",
      "startReview": "Commencer l’examen",
      "summary": "Sommaire",
      "requesterDetails": "Renseignements sur le demandeur",
      "assigneeDetails": "Renseignement sur le responsable",
      "manageAssignees": "Gérer les assignées"
    },
    "researcherInformation":{
      "title": "Détails de la demande",
      "description": "Statistique Canada doit contrôler les données statistiques de sortie pour assurer la protection des données. Les analystes de Statistique Canada examineront toutes les demandes de contrôle de la confidentialité des utilisateurs externes. Ces demandes font l’objet d’une évaluation de la divulgation potentielle, axée sur les risques et fondée sur des règles et des procédures établies.",
      "requestDetails": "Détails de la demande", 
      "details": "Détails", 
      "requestId": "ID de la demande", 
      "requestName": "Nom de la demande", 
      "project": "Projet",
      "requester": "Demandant",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Courriel",
      "createdOn": "Créée",
      "updatedOn": "Mise à jour",
      "username": "Nom d'utilisateur",
      "role": "Rôle"
    },
    "filesList":{
      "title": "Fichiers de sortie aux fins de contrôle de la confidentialité",
      "outputFiles": "Fichiers de sortie",
      "outputFilesTip": "Ajoutez les fichiers contenant vos résultats statistiques que vous aimeriez faire approuver et diffuser à partir de l’environnement sécurisé.",
      "explanation": "Veuillez préparer et ajouter vos fichiers aux fins de contrôle de la confidentialité. Vous n’aurez pas accès à vos fichiers à partir de cette demande et vous ajoutez simplement le chemin d’accès aux fichiers pour aider les analystes à trouver le fichier sur votre machine virtuelle. Si votre demande est approuvée, vous aurez accès à vos dossiers en dehors de votre environnement sécurisé.",
      "screeningQuestions": "Questions de sélection",
      "pleaseConsider": "Veuillez tenir compte des lignes directrices suivantes :",
      "checkAgainstGuidelines": "Vérifiez votre produit en fonction des lignes directrices relatives au contrôle de la confidentialité.",
      "deleteNotNeeded": "Supprimez les valeurs dont vous n’avez pas besoin pour le moment.",
      "requestStored": "Cette demande sera stockée dans le dossier de demande.",
      "consistentOutput": "Le produit demandé est-il conforme à la proposition approuvée pour ce projet?",
      "vettingRules": "Avez-vous vérifié les règles de contrôle de la confidentialité afin de vérifier s’il existe des exigences spécifiques pour votre produit (p.ex. des régions géographiques, des établissements, des tailles de ménages, des populations, des entreprises, etc.)?",
      "finalOutput": "Est-ce que le produit demandé est bel et bien votre produit final?",
      "finalOutputTip": "Si non, les futures demandes de contrôle de la confidentialité envoyées en vertu de ce contrat pourraient être limitées à cause du risque de divulgation par recoupement. Nous vous encourageons fortement à consulter votre Analyste.",
      "requestFolder": "Le chemin d’accès au dossier de la demande",
      "areYouSureOutput": "Êtes-vous sûr de vouloir continuer avec cette action? Ceci va réinitialiser la liste de produits associés avec cette demande",
      "edit": "Modifier",
      "view": "Voir",
      "review": "Réviser",
      "outputError": "{{count}} erreur",
      "outputError_plural": "{{count}} erreurs",
      "maxOutputFiles": "Nombre maximum de fichers de sortie atteints",
      "maxSupportFiles": "Nombre maximum de fichers de support atteints",
      "mandatorySupportingFiles": "Fichiers de support obligatoires",
      "mandatorySupportingFilesTip": "Ces fichiers doivent étayer la demande de contrôle de la confidentialité et ne seront pas diffusés",
      "variableListFileTip": "Inclure les renseignements pour les variables dérivées ou recodées (p. ex. syntaxe, livre de codes, description).",
      "additionalSupportingFiles": "Fichiers de support additionnels",
      "finalOutputGuidelines" : "Les futures demandes de contrôle de la confidentialité envoyées en vertu de ce contrat pourraient être limitées à cause du risque de divulgation par recoupement. Nous vous encourageons fortement à consulter votre analyste.",
      "finalOutputGuidelinesPara2" : "Les projets économiques sont censés avoir une production intermédiaire limitée. En raison de la divulgation résiduelle, le résultat demandé doit être aussi proche que possible du résultat final. Les itérations multiples du résultat ne seront pas publiées, sauf si une revue académique/journalistique a été demandée pour le projet. Consultez votre analyste pour connaître les stratégies de diffusion des résultats intermédiaires."
    },
    "modifyFile":{
      "addOutputFile": "Ajout d’un fichier de sortie",
      "editOutputFile": "Modification d’un fichier de sortie",
      "viewOutputFile": "Affichage d’un fichier de sortie",
      "reviewOutputFile": "Révision d’un fichier de sortie",
      "selectOutput": "Choisir le fichier de sortie pour la divulgation",
      "outputFile": "Chemin d’accès au fichier",
      "sheetName": "Nom de la feuille",
      "sheetNameHelper": "Pour les chiffriers seulement.",
      "outputDetails": "Détails de la sortie",
      "datasetName": "Nom(s) de l’enquête ou de l’ensemble de données et cycle(s)",
      "datasetNameHelper": "Séparez chacun par un point virgule (p. ex. EPA 2012; EPA 2011; ESCC 2009)",
      "outputMethod": "Méthode relative aux données de sortie",
      "outputMethodDescription": "Description de la méthode relative aux données de sortie",
      "needHelp": "Besoin d'aide?",
      "outputMethodLearn": "Apprendre à propos des méthodes relatives aux données de sortie",
      "methods": {
        "descriptiveMethod": "Descriptif", 
        "descriptiveMethodExamples": ["Analyse de la variance",
          "Matrice des corrélations",
          "Analyse par recoupement",
          "Répartitions",
          "Fréquences",
          "Aplatissement",
          "Moyennes",
          "Médianes",
          "Modes",
          "Pourcentages",
          "Quartiles",
          "Plages",
          "Rapports",
          "Modèles de régressions avec une seule variable",
          "Asymétrie",
          "Écarts-types",
          "Totaux",
          "Variances"],
        "scalingMethod": "Mise à l’échelle",
        "scalingMethodExamples": ["Analyse factorielle"],
        "graphsMethod": "Graphiques",
        "graphsMethodExamples": ["Histogrammes"],
        "regressionMethod": "Analyse de régression multidimensionnelle",
        "regressionMethodExamples": ["Logit",
          "MCO",
          "Poisson",
          "Probit",
          "Tobit"],
        "modelingMethod": "Modélisation complexe",
        "modelingMethodExamples": ["Analyse de données longitudinales",
          "Modèles à effets fixes",
          "Analyse de croissance",
          "Modélisation linéaire hiérarchique",
          "Modèle à effets aléatoires",
          "Modèles d’équations simultanées",
          "Modélisation par équations structurelles",
          "Analyse de survie"],
        "otherMethod": "Autres"
      },
      "examplesInclude": "Parmi les exemples figurent les suivants: {{content}}",
      "weightedVariable": "Variable de pondération",
      "includeWeightVariable": "Est-ce que ce produit contient une variable de pondération?",
      "weightVariableName": "Nom de la variable de pondération",
      "weightVariableType": "La variable pondéré était-elle échelonnée/normalisée?",
      "sampleUsed": "Échantillon, sous-échantillon ou inclusions/exclusions utilisés?",
      "sampleUsedHelper": "(p. ex. femmes employées, âgées de 21 à 45 ans, en Ontario)",
      "sampleUsedTooltip": "Décrivez chacun des différents échantillons, sous-échantillons ou des différentes inclusions/exclusions utilisés pour produire vos données de sortie.",
      "geographyLevel": "Niveau de géographie",
      "geographyLevelHelper": "Exemples: national, provincial",
      "linkedDataTitle": "Données couplées",
      "linkedData": "Est-ce que des données couplées sont utilisées?",
      "linkedDataDescription": "Méthode de couplage",
      "linkedDataDescriptionHelper": "(p. ex. fondé sur la personne, fondé sur l’enregistrement, correspondances géographiques)",
      "descriptiveStatsTitle": "Statistiques descriptives",
      "descriptiveStats": "Cette demande comprend-elle des statistiques descriptives?",
      "outputLabelled": "Est-ce que le produit est clairement étiquté (les tableaux ont un titre et chaque variable et catégorie est étiquetée)?",
      "minCellSize": "Est-ce que la taille minimale des cellules est respectée conformément aux règles applicables aux données?",
      "correctDocFileTip": "(p. ex. chiffres non pondérés; pondérés; pondérés et arrondis)",
      "equivalentDescriptiveStats": "Cette demande inclut-elle un produit de modèle ou des graphiques qui sont équivalents à une statistique descriptive?",
      "equivalentDescriptiveStatsTip": "Exemples: un modèle comportant une variable indépendante, un modèle comportant toutes les interactions possibles, histogrammes",
      "matrixTitle": "Matrice de corrélation/covariance",
      "includeMatrix": "Cette demande comprend-elle une matrice des corrélations ou de covariance?",
      "continuousVariables": "La matrice contient-elle des variables continues?",
      "dichotomousVariables": "La matrice contient-elle des variables dichotomiques?",
      "correlatedVariables": "La matrice contient-elle une variable dichotomique corrélée avec une variable continue?",
      "rounding": "Arrondissement",
      "roundingOutput": "L’arrondissement des données du produit est-il requis pour cette demande de contrôle de la confidentialité?",
      "roundingOutputTip": "Si oui, assurez-vous que tout arrondissement forcé à zéro est clairement indiqué.",
      "roundingOutputDescription": "Description de la méthode d’arrondissement",
      "dominanceTesting" : "Test de dominance",
      "dominanceTestingOutput" : "La sortie contient-elle des variables qui nécessitent un test de dominance (voir les lignes directrices) ?",
      "economicData":"Données économiques",
      "economicDataOutput":"Votre résultat est-il généré à partir de données économiques ?",
      "uniqueDataUnits":"Les résultats (c'est-à-dire les statistiques descriptives et le nombre d'observations dans un modèle) répondent-ils aux exigences relatives au nombre minimum d'unités de données uniques ?",
      "outputContinuousVariables":"Votre résultat contient-il des variables continues ?",
      "continuousVariablesSensitivity":"Toutes les variables continues répondent-elles aux exigences de sensibilité définies dans les règles de contrôle ?",
      "reviseOutput":"Veuillez réviser vos résultats ou en discuter avec votre analyste.",
      "additionalSupportingFiles": "Fichiers justificatifs additionnels",
      "add": "Ajouter",
      "update": "Mettre à jour",
      "keepAnswersTitle": "Changement de fichier",
      "keepAnswers": "Voudrez-vous garder vos réponses pour ce fichier?",

      "addSupportingFilesTitle_syntaxFile": "Ajoutez un fichier de syntaxe ou un fichier journal",
      "addSupportingFilesTitle_variableListFile": "Ajoutez une liste de variables et/ou des descriptions de variables",
      "addSupportingFilesTitle_other": "Ajoutez un fichier justificatif supplémentaire",
      "addSupportingFilesTitle_correctDocFile": "Ajoutez les documents justificatifs adéquats (voir les règles de contrôle de la confidentialité)",
      "addSupportingFilesTitle_frequencyTablefile": "Ajoutez un tableau de fréquences non pondérées pour le nombre de répondants",
      "addSupportingFilesTitle_sampleSizeFile": "Ajoutez une taille non pondérée d’échantillon",
      "addSupportingFilesTitle_crossTabFile": "Ajoutez un tableau croisé non pondéré",
      "addSupportingFilesTitle_subTotalsFile": "Ajoutez les sous-totaux non pondérés pour les catégories de variables dichotomiques corrélées avec une variable continue",
      "addSupportingFilesTitle_subTotalsFile_para2": "Pour les résultats générés à partir de données économiques, fournir également le test de sensibilité de la variable continue pour chaque catégorie",
      "addSupportingFilesTitle_unroundedFile": "Ajoutez une version non arrondie de ces données de sortie",
      "addSupportingFilesTitle_residualTablesFile": "Ajoutez un tableau résiduel (voir l’orientation du contrôle de la confidentialité)",

      "addSupportingFilesTitle_dominanceTestingFile" : "Ajouter les résultats des tests",
      "addSupportingFilesTitle_dominanceTestingFile_note" : "Remarque : pour éviter d'ajouter les fichiers individuellement, ils peuvent être compressés dans un seul fichier et ajoutés ensemble.",
      "addSupportingFilesTitle_continuousVariablesSensitivityFile":"Ajouter les résultats du test de sensibilité",
      "addSupportingFilesTitle_continuousVariablesSensitivityFile_note":"Remarque : pour éviter d'ajouter les fichiers individuellement, ils peuvent être compressés dans un seul fichier et ajoutés ensemble.",

      "addSupportingFilesTitle_previousRelease_residualTablesFile": "Ajoutez un tableau résiduel (voir l’orientation du contrôle de la confidentialité)",
      "addSupportingFilesTitle_bothSetsFile": "Ajoutez les deux ensembles de syntaxe dans lesquels des changements sont mis en évidence",
      "addSupportingFilesTitle_previousRelease_bothSetsFile": "Ajoutez les deux ensembles de syntaxe dans lesquels des changements sont mis en évidence",
      "addOutputFileTitle": "Ajoutez un fichier de sortie aux fins de contrôle de la confidentialité",
      "addSupportingFilesOneFile": "Au moins un fichier doit être ajouté",
      "addSupportingFilesButton": "Ajout d’un fichier justificatif",
      "addOutputFileButton": "Ajout d’un fichier de sortie",
      "addSupportingFilesCardTitle": "Fichier {{index}} · $t(requestForm.supportingFiles.{{fileType}})",
      "addOutputFileCardTitle": "Fichier {{index}} · Fichier de sortie pour la divulgation",
      "addSupportingFilesEdit": "Modifier",
      "addSupportingFilesDelete": "Supprimer",
      "addSupportingFilesFilePath": "Chemin d’accès au fichier",
      "addSupportingFilesNotes": "Notes",
      "addSupportingFilesNoOutput": "Aucun fichier de sortie n’a été ajouté",
      "addSupportingFilesNoSupport": "Aucun fichier justificatif n’a été ajouté"
    },
    "residualDisclosure":{
      "title":"Divulgation par recoupement",
      "description": "Une rediffusion du même fichier de sortie après modifications augmente le risque de divulgation par recoupement. Statistique Canada recommande fortement que les chercheurs soumettent un nombre minimal de version du fichier de sortie.",
      "subsetVariables": "Pour cette demande, avez-vous des sous-ensembles de variables, où une ou plusieurs variables sont un sous-ensemble d'une autre ? ",
      "subsetVariablesTip": "(p. ex. souffrait de dépression au cours des cinq dernières années et souffrait de dépression au cours de l’année précédente; souffrait d’une maladie chronique et d’un problème respiratoire chronique)",
      "subsetVariables_changedSubSample": "Comparé à l'autre sous-ensemble, avez-vous changé le sous-échantillon ou la population d’intérêt?",
      "subsetVariables_droppedOutliers": "Comparé à l'autre sous-ensemble, avez-vous abandonné des cas individuels ou des valeurs aberrantes?",
      "subsetVariables_imputedData": "Comparé à l'autre sous-ensemble, avez-vous imputé les valeurs manquantes?",
      "subsetVariables_modifiedVariables": "Comparé à l'autre sous-ensemble, avez-vous recodé ou modifié des variables, même légèrement?",
      "previousRelease": "Une version de ce produit, partielle ou intégrale, a-t-elle déjà été diffusée?",
      "previousRelease_changedSubSample": "Comparé à l'autre produit, avez-vous changé le sous-échantillon ou la population d’intérêt?",
      "previousRelease_droppedOutliers": "Comparé à l'autre produit, avez-vous abandonné des cas individuels ou des valeurs aberrantes?",
      "previousRelease_imputedData": "Comparé à l'autre produit, avez-vous imputé les valeurs manquantes?",
      "previousRelease_modifiedVariables": "Comparé à l'autre produit, avez-vous recodé ou modifié des variables, même légèrement?",
      "listSubsetted": "Liste des sous-ensembles de variables",
      "explainChanges": "Explication des changes",
      "dateRelation": "Date de la demande reliée",
      "dateRelationHelper": "Indiquez la ou les dates des demandes de contrôle de la confidentialité précédentes liées à cette demande."
    },
    "additionalInformation":{
      "title": "Information additionnelle",
      "text": "Utilisez cette section pour ajouter des commentaires supplémentaires qui pourraient être utile à l'analyste pour faire la revue de votre demande de contrôle de la confidentialité."
    },
    "supportingFiles":{
      "correctDocFile": "Documents justificatifs adéquats (voir les règles de contrôle de la confidentialité)",
      "correctDocFile_noExplain": "Documents justificatifs adéquats",
      "frequencyTablefile": "Tableau de fréquences non pondérées pour le nombre de répondants",
      "sampleSizeFile": "Taille non pondérée de l’échantillon",
      "crossTabFile": "Tableau croisé non pondéré",
      "subTotalsFile": "Sous-totaux non pondérés pour les catégories de variables dichotomiques corrélées avec une variable continue",
      "unroundedFile": "Version non arrondie de ces données de sortie",
      "syntaxFile": "Fichier de syntaxe ou fichier journal",
      "variableListFile": "Liste de variables et/ou descriptions de variables",
      "residualTablesFile": "Tableau résiduel (voir l’orientation du contrôle de la confidentialité)",
      "residualTablesFile_noExplain": "Tableau résiduel",
      "bothSetsFile": "Les deux ensembles de syntaxe dans lesquels des changements sont mis en évidence",
      "other": "Autre",
      "additionalDetails": "Fichier justificatif supplémentaire",
      "dominanceTestingFile": "Résultats des tests",
      "continuousVariablesSensitivityFile": "Résultats du test de sensibilité"
    }
  },
  "inactiveWindowTabTitle": "Onglet inactif",
  "applicationErrorMessage":{
    "request":{
      "requiredErrorMessage": "Ce champ est obligatoire.",
      "formErrors": "La demande n’a pas été soumise ({{count}} erreur)",
      "formErrors_plural": "La demande n’a pas été soumise ({{count}} erreurs)",
      "intenseFormErrors": "La demande n’a pas été soumise (99+ erreurs)",
      "invalidOutputs": "Les fichiers de sortie de la demande ne sont pas valides.",
      "invalidFiles": "Certains fichiers de la demande ne sont pas valides.",
      "requestErrorDeleting":"Erreur lors de la suppression de la demande.",
      "unauthorizedUserRole": "Vous n’êtes pas autorisé à effectuer cette action.",
      "requestNotFound": "La demande est introuvable.",
      "unauthorizedEditRequest": "Vous n’êtes pas autorisé à modifier cette demande.",
      "submitError": "Une erreur s’est produite lors de la soumission.",
      "copyError": "Une erreur s’est produite lors de la copie des fichiers.",
      "invalidProject": "Projet invalide; données actualisées",
      "invalidRequestStatus": "Statut invalide",
      "unexpectedError": "Une erreur inattendue s’est produite.",
      "deletedFile": "Ce fichier a été supprimé.",
      "accessKeyError": "Une erreur s’est produite lors de l’obtention de la clé d’accès Azure.",
      "helpAlreadySent":"Une demande d’aide a déjà été envoyée pour cette demande.",
      "requestCantTransferFile":"Les fichiers n’ont pas pu être transférés. Veuillez réessayer.",
      "notLoggedIn": "Vous n'avez pas une session active. Veuillez rafraîchir votre furteur.",
      "invalidRate":"Vous ne pouvez pas créér une nouvelle requête en ce moment. Veuillez réessayer de nouveau.",
      "invalidRequestFolder":"Le chemin d’accès du dossier n’est pas valide."
    },
    "generic":{
      "dataError": "Une erreur est survenue au moment d’obtenir les données Veuillez essayer de nouveau.",
      "projectError": "Une erreur s’est produite lors de la configuration du projet. Veuillez essayer de nouveau.",
      "unexpectedError": "Une erreur inattendue s’est produite.",
      "missingRequiredField":"Un ou plusieurs champs obligatoires sont manquants.",
      "notLoggedIn":"Vous n'avez pas une session active. Veuillez rafraîchir votre furteur.",
      "tabInactive": "Cet onglet n'est plus actif. Veuillez le fermer.",
      "userNotExistDatabase": "Votre compte n'existe pas dans notre base de données. Veuillez sélectionner votre compte Cloud authorisé VDL en utilisant le",
      "userNoProjects": "Vous n'avez pas de projets actifs.",
      "unexpectedBrowserError": "Une erreur inattendue s’est produite. Veuillez rafraîchir votre furteur."
    }
  }
}